export enum Type {
  CLAIM_PODCAST_INIT = 'app/claim-podcast/CLAIM_PODCAST_INIT',
  CLAIM_PODCAST_REQUEST = 'app/claim-podcast/CLAIM_PODCAST_REQUEST',
  CLAIM_PODCAST_FAILURE = 'app/claim-podcast/CLAIM_PODCAST_FAILURE',
  CLAIM_PODCAST_SUCCESS = 'app/claim-podcast/CLAIM_PODCAST_SUCCESS',
  GET_OWNED_PODCASTS_REQUEST = 'app/claim-podcast/GET_OWNED_PODCASTS_REQUEST',
  GET_OWNED_PODCASTS_FAILURE = 'app/claim-podcast/GET_OWNED_PODCASTS_FAILURE',
  GET_OWNED_PODCASTS_SUCCESS = 'app/claim-podcast/GET_OWNED_PODCASTS_SUCCESS',
}
